import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const AdminDashboardApiSlice = createApi({
  reducerPath: "adminDashboardApiSlice",
  baseQuery: customBaseQuery,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 10,
  endpoints: (builder) => ({
    filterAssignmentv2: builder.query({
      query: ({ artifactId, userId, progressType }) => ({
        url: "/graphql",
        body: gql`
          query FilterAssignmentv2(
            $artifactId: UUID!
            $userId: [UUID]
            $progressType: String
          ) {
            filterAssignmentv2(
              request: {
                artifactId: $artifactId
                filter: { progressType: $progressType, assignedByList: $userId }
              }
            ) {
              data {
                contentAndProgressList {
                  id
                  artifacttype
                  title
                  shortdescription
                  longdescription
                  language
                  duration
                  difficultylevel
                  branding {
                    promo
                    thumbnail
                    banner
                  }
                  sourcename
                  sourcetype
                  prerequisite
                  learningobjective
                  demonstrableoutcome
                  brandingurls {
                    promo
                    thumbnail
                    banner
                  }
                  assignments {
                    assignmentId
                    progressType
                    user {
                      id
                      name {
                        firstName
                        lastName
                        fullName
                      }
                      email
                    }
                    groups
                    deadline
                    remarks
                    assignedBy {
                      id
                      name {
                        firstName
                        lastName
                        fullName
                      }
                      email
                    }
                    assignedAt
                    commencementDate
                    progressPercentage
                    completedAt
                  }
                }
                assignedBy {
                  id
                  name {
                    firstName
                    lastName
                    fullName
                  }
                  email
                }
                assignedTo {
                  id
                  name {
                    firstName
                    lastName
                    fullName
                  }
                  email
                }
              }
            }
          }
        `,
        params: {
          variables: {
            artifactId,
            userId: [userId],
            progressType
          }
        }
      }),
      extraOptions: { service: "Catalog" }
    }),
    filterAssignmentPaginated: builder.query({
      query: ({ artifactId, userId, pageNumber }) => ({
        url: "/graphql",
        body: gql`
          query FilterAssignmentPaginated(
            $artifactId: String!
            $userId: String!
            $pageNo: Int
          ) {
            filterAssignmentPaginated(
              request: { artifactId: $artifactId, assignedBy: $userId }
              pageNo: $pageNo
              pageSize: 5
            ) {
              error
              data {
                totalCount
                title
                artifactType
                sourceType
                sourceName
                shortDescription
                language
                duration
                difficultyLevel
                branding {
                  thumbnail
                }
                brandingurls {
                  thumbnail
                }
                assignments {
                  assignmentId
                  user {
                    id
                    email
                    name {
                      fullName
                    }
                  }
                  progressPercentage
                  commencementDate
                  assignedAt
                }
              }
            }
          }
        `,
        params: {
          variables: {
            artifactId: artifactId,
            userId: userId,
            pageNo: pageNumber
          }
        }
      }),
      extraOptions: { service: "Catalog" }
    }),
    fetchGroupsforArtifact: builder.query({
      query: ({ artifactId, userId }) => ({
        url: "/graphql",
        body: gql`
          query FetchGroupsforArtifact($artifactId: String!, $userId: String!) {
            fetchGroupsforArtifact(
              request: { artifactId: $artifactId, assignedBy: $userId }
            ) {
              error
              data {
                artifactId
                artifactType
                title
                shortDescription
                groups {
                  id
                  title
                  users
                  status
                  progress
                }
              }
            }
          }
        `,
        params: {
          variables: {
            artifactId: artifactId,
            userId: userId
          }
        }
      }),
      extraOptions: { service: "Catalog" }
    }),
    fetchUserGroupByStakeholderPaginated: builder.query({
      query: (searchQuery) => ({
        url: "/graphql",
        body: gql`
          query  {
            fetchUserGroupByStakeholderPaginated(
              searchCriteria: { title: "${searchQuery}" }
              sortCriteria: {}
            ) {
              data {
                totalCount
                userGroup{
                  userGroupId
                  title
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Utility" }
    }),
    fetchAvgLearningPathProgress: builder.query({
      query: ({ learningPathId, assignedBy }) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchAvgLearningPathProgress(
              request: {
                searchCriteria: {
                  learningPathId: "${learningPathId}"
                  assignedBy: "${assignedBy}"
                }
                sortCriteria: { sortKey: "SECTION_PROGRESS", sortOrder: "ASC" }
              }
            ) {
              data {
                id
                title
                progress
                sectionList {
                  id
                  title
                  progress
                  connectionList {
                    id
                    title
                    nextSectionId
                    sourceSectionId
                  }
                  contentList {
                    id
                    title
                    progress
                    contentType
                  }
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Progress" }
    }),
    getProfileForSupervisor: builder.query({
      query: (uid) => ({
        customuuid: uid,
        url: "/graphql",
        body: gql`
          query {
            getProfileForSupervisor(
              pageNumber: 1
              pageSize: 12
              sortOrder: "asc"
              sortKey: "name"
            ) {
              error
              data {
                totalCount
                myReportees {
                  userId
                  email
                  name {
                    fullName
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "PID" }
    }),
    fetchLearningPathProgress: builder.query({
      query: (learningPathId) => ({
        url: "/graphql",
        body: gql`
          query FetchLearningPathProgress($learningPathId: String!) {
            fetchLearningPathProgress(learningPathId: $learningPathId) {
              data {
                learningPathId
                userId
                progressPercentage
                status
                org
                createdat
                updatedat
                completedat
                createdZoneId
                updatedZoneId
                completedZoneId
                sectionList {
                  sectionId
                  userId
                  progressPercentage
                  startedat
                  updatedat
                  completedat
                  locked
                  completedBySystem
                  contentList {
                    contentId
                    contentType
                    progressPercentage
                    startedat
                    createdat
                    updatedat
                    completedat
                    locked
                    completedBySystem
                  }
                }
              }
            }
          }
        `,
        params: {
          variables: {
            learningPathId: learningPathId
          }
        }
      }),
      extraOptions: { service: "Progress" }
    }),
    fetchCourseProgress: builder.query({
      query: (courseId) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchAvgCourseProgress(
              request: {
                searchCriteria: {
                  courseId: "${courseId}"
                }
                sortCriteria: { sortKey: "MODULE_PROGRESS", sortOrder: "DESC" }
              }
            ) {
              timestamp
              version
              error
              data {
                id
                title
                progress
                moduleList {
                  id
                  title
                  progress
                  chapterList {
                    id
                    title
                    progress
                    contentType
                  }
                  connectionList {
                    id
                    title
                    sourceModuleId
                    nextModuleId
                  }
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Progress" }
    }),
    filterGroupUserAssignment: builder.query({
      query: ({ artifactId, userId, progressType, groupId }) => ({
        url: "/graphql",
        body: gql`
          query FilterAssignmentv2(
            $artifactId: UUID!
            $userId: [UUID]
            $progressType: String
            $groupId: UUID
          ) {
            filterAssignmentv2(
              request: {
                artifactId: $artifactId
                filter: {
                  progressType: $progressType
                  assignedByList: $userId
                  groupId: $groupId
                }
              }
            ) {
              data {
                contentAndProgressList {
                  id
                  artifacttype
                  title
                  shortdescription
                  longdescription
                  language
                  duration
                  difficultylevel
                  branding {
                    promo
                    thumbnail
                    banner
                  }
                  sourcename
                  sourcetype
                  prerequisite
                  learningobjective
                  demonstrableoutcome
                  brandingurls {
                    promo
                    thumbnail
                    banner
                  }
                  assignments {
                    assignmentId
                    progressType
                    user {
                      id
                      name {
                        firstName
                        lastName
                        fullName
                      }
                      email
                    }
                    groups
                    deadline
                    remarks
                    assignedBy {
                      id
                      name {
                        firstName
                        lastName
                        fullName
                      }
                      email
                    }
                    assignedAt
                    commencementDate
                    progressPercentage
                    completedAt
                  }
                }
                assignedBy {
                  id
                  name {
                    firstName
                    lastName
                    fullName
                  }
                  email
                }
                assignedTo {
                  id
                  name {
                    firstName
                    lastName
                    fullName
                  }
                  email
                }
              }
            }
          }
        `,
        params: {
          variables: {
            artifactId,
            userId: [userId],
            progressType,
            groupId: groupId
          }
        }
      }),
      extraOptions: { service: "Catalog" }
    }),
    unassignGroup: builder.mutation({
      query: ({ id, data }: { id: string; data: string }) => ({
        url: `/group-assignment/unassign/${id}`,
        method: "PUT",
        body: { data }
      }),
      extraOptions: { service: "Catalog" }
    })
  })
});

export const {
  useFilterAssignmentv2Query,
  useLazyFilterGroupUserAssignmentQuery,
  useFilterAssignmentPaginatedQuery,
  useUnassignGroupMutation,
  useFetchGroupsforArtifactQuery,
  useFetchUserGroupByStakeholderPaginatedQuery,
  useFetchAvgLearningPathProgressQuery,
  useLazyFetchUserGroupByStakeholderPaginatedQuery,
  useGetProfileForSupervisorQuery,
  useLazyGetProfileForSupervisorQuery,
  useFetchLearningPathProgressQuery,
  useFetchCourseProgressQuery
} = AdminDashboardApiSlice;
